interface AvatarDimensions {
  size: number;
  fontSize: number;
}

interface AvatarConfig {
  HEADER_SIZE: number;
  CONTACT_CARD_SIZE: number;
  getFontSize: (avatarSize: number) => number;
  getIconSize: (avatarSize: number) => number;
  HEADER_DIMENSIONS: AvatarDimensions;
  CONTACT_CARD_DIMENSIONS: AvatarDimensions;
}

const _HEADER_SIZE = 80;
const _CONTACT_CARD_SIZE = 30;
const _getAvatarFontSize = (avatarSize: number): number => avatarSize / 2.6;
const _getAvatarIconSize = (avatarSize: number): number => avatarSize * 0.6;

export const AVATAR_CONFIG: AvatarConfig = {
  HEADER_SIZE: _HEADER_SIZE,
  CONTACT_CARD_SIZE: _CONTACT_CARD_SIZE,
  getFontSize: _getAvatarFontSize,
  getIconSize: _getAvatarIconSize,
  HEADER_DIMENSIONS: {
    size: _HEADER_SIZE,
    fontSize: _getAvatarFontSize(_HEADER_SIZE),
  },
  CONTACT_CARD_DIMENSIONS: {
    size: _CONTACT_CARD_SIZE,
    fontSize: _getAvatarFontSize(_CONTACT_CARD_SIZE),
  },
};
